import sucessIcon from "../Assets/imgs/landing/sucessIcon.webp";
import { useLocation } from "react-router-dom";
import failureIcon from "../Assets/imgs/landing/oopsIcon.webp";
import { NavigateToHome } from "../utils/CommonFunctions";
const JazzCashResponsePage = () => {
  const { state } = useLocation();

  return (
    <>
      <div className={`landing--modal--box`}>
        <img src={state?.success ? sucessIcon : failureIcon} alt="star" />
        <div className="mubarakhead">
          {state?.success ? "Congratulations" : "Failed"}
        </div>
        <div className="mubaraltext mb-4">
          {state?.success
            ? "Your Policay has been successfully purchased."
            : state?.message || "Your payment has failed. Please try again."}
        </div>
        <button
          className="close--button"
          onClick={() => {
            NavigateToHome();
          }}
        >
          Close
        </button>
      </div>
      <div className="cong--overlay"></div>
    </>
  );
};

export default JazzCashResponsePage;
